<script>
export default {
  name: "CountryLocation",
  data() {
    return {
      countryCode: "GB"
    };
  },
  async created (){
      const locationCon = this.axios.create({})
      await locationCon.get('/api/payment-location')
      .then((response) => {
          // handle success
          this.$root.countryCode =  response.data.data.countryCode;
          this.getVatRate();
        })
        .catch(() => {
          locationCon.get("https://ipapi.co/json/")
          .then((response) => {
              this.$root.countryCode = response.data.country_code;
              this.getVatRate();
          })
          .catch(() => {
            this.$root.countryCode = 'GB'
          })
        }) 
  },
  methods: {
    async getVatRate() {
      const vatRateCon = this.axios.create({})
      await vatRateCon.get('/api/customer-vat-rate/' + this.$root.countryCode)
      .then((response) => {
        this.$root.vatRate = ((response.data.data.vatRate)/100) + 1;
      })
        .catch(() => {
          this.$root.vatRate = 1.2;
      })
    },
    toggleVAT() {
      this.$root.showVAT = !this.$root.showVAT;
    }
  },
};
</script>
<template>
  <!--<div id="vat-selector">
        <span class="vat">VAT</span>
        <input type="checkbox" id="vat-toggle" v-model="checked">
        <label for="checkbox">{{ checked }}</label>
        <country-flag :country='countryCode' size='normal'/>
        <span class="country">{{countryCode}}</span>
    </div>-->

  <div id="vat-selector">
      <span class="vat-text" v-if="this.$root.showVAT === false">Hiding VAT</span>
      <span class="vat-text" v-if="this.$root.showVAT == true">Showing VAT</span>  <!--Can the vat-text div update to 'hide VAT' upon toggle? -->
    <div class="checkbox">
      <input v-on:click="toggleVAT()" id="vat-toggle" name="vat-toggle" type="checkbox" value="1" />
      <label class="toggle" for="vat-toggle"></label>
      <div></div>
    </div>
      <country-flag :country="this.$root.countryCode" size="normal" v-if="this.$root.countryCode !== null"></country-flag>
      <span class="country" v-if="this.$root.countryCode !== null">{{ this.$root.countryCode }}</span>
  </div>
</template>

             .-----.
            /       `\
          _|_         |
         /   \        | 
         '==='        |


         . ' .        |
        . : ' .       |
           '.         |
       . '    .       |
        .-"""-.       |
       /  \___ \      |
       |/`    \|      |
       (  a  a )      |
       |   _\ |       |
       )\  =  /       |
   _.-'  '---;        |
 /`           `-.     |
|                \    |
|    |   .  & .   \   |
\    /      &   |  ;  |
|   |           |  ;  |
|   /\          /  |  |
\   \ )   -:-  /\  \  |
 `.  `-.  -:-  | \  \_|
   '-.  `-.    (  './\`\
    / `'-. `\  |    \/_/
    |    \  |  |      |
    |    /'-\  /      |
     \   \   | |      |
      \   )_/\ |      |
       \      \|      |
        \      \      |
         '.     |     |
           /   /      |
          /  .';      |
        /`  /  |      |
       /   /   |      |
 jgs  |  .' \  |      |
      /  \  )  |      |
      \   \ /  '-.._  |
       '.ooO\__._.Ooo |


<!-- BEGIN STYLING -->
<style lang="scss" scoped>
#vat-selector {
    display:flex;
        display: flex;
    align-items: center;

    .vat-text {
      text-align:right;
      width:70px;
    }
  .checkbox {
    width: 30px;
    height: 16px;
    margin: 0px 8px 0px 3px;
    position: relative;
    display: inline-block;

    & + label {
      position: relative;
      top: -2px;
    }
  

  div {
    width: 100%;
    height: 100%;
    background: #2f4340;
    border-radius: 50px;
    position: absolute;
    top: 0px;
  }

  label {
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 50px;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    cursor: pointer;
    position: absolute;
    top: 1px;
    z-index: 1;
    left: 1px;
    background: white;
    padding: initial;
    margin: initial;
  }

  input[type="checkbox"]:checked ~ div {
    background: #2f4340;
  }

  input[type="checkbox"]:checked ~ label {
    left: 15px;
  }
}

.normal-flag {
    margin: 0px;
    margin-right:0px;
    border-radius: 5px;
}

}
</style>
